import { Button, Icon, Typography } from '@/components';
import { OpportunityDetails } from '@/features/opportunities/types';
import { useTranslation } from 'react-i18next';

export type AboutTheSellerBoxProps = {
  readonly opportunity: OpportunityDetails;
  readonly onEdit?: () => void;
  readonly isEditable: boolean;
};

export function AboutTheSellerBox({ opportunity, onEdit, isEditable }: AboutTheSellerBoxProps) {
  const { t } = useTranslation(['opportunities']);

  return (
    <div className="flex">
      <div className="flex-1 rounded-lg border border-neutral-50 bg-white p-6 shadow-xs">
        <div className="mb-3 flex items-center">
          <div className="mr-2 flex h-10 w-10 items-center justify-center rounded-full bg-neutral-50">
            <Icon name="buildings" className="h-6 w-6" />
          </div>
          <Typography as="h3" weight="semibold" size="title">
            {t('About the Seller')}
          </Typography>
          {isEditable && (
            <Button size="sm" color="neutral" icon="edit" onClick={onEdit} className="ml-auto">
              {t('Edit')}
            </Button>
          )}
        </div>
        <span className="text-base font-normal whitespace-pre-wrap text-neutral-900">
          {opportunity.aboutYou ?? t('No info available')}
        </span>
      </div>
    </div>
  );
}
